<template>
    <div class="task-content" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
        </div>

        <div class="new-content">
            <div class="task-header">
                {{ taskTitle && newTaskTitleTxt ? taskTitle + '(' + newTaskTitleTxt + ')' : taskTitle || '配置任务包' }}
                <span class="lock-state" v-if="detail.lockStatus == 1">已锁定</span>
            </div>
            <div class="task-content">
                <section class="item">
                    <div>产品类别：{{ getName(detail.productCategoryList, '超级模版-对应产品类别') }}</div>
                    <div>项目运营人：{{ getMangeName(detail.projectManagerStaffList) }}</div>
                </section>
                <section class="item">
                    <div>执行日期：{{ startTime }} 至 {{ endTime }}</div>
                </section>
            </div>

        </div>

        <!-- 任务明细 开始 -->
        <div class="title" style="margin-bottom: 0 !important;">任务明细</div>

        <div class="back-color-fff p20">
            <el-table style="width: 100%" :data="tableDataII" border stripe header-cell-class-name="table_header">
                <el-table-column prop="parentTemplateDetailName" label="平台任务名称" width="200" show-overflow-tooltip
                    header-align="center" align="left">
                    <template slot-scope="scope">{{ scope.row.parentTemplateDetailName || '-' }}</template>
                </el-table-column>
                <el-table-column prop="taskContentName" label="项目任务名称" width="200" show-overflow-tooltip
                    header-align="center" align="left">
                </el-table-column>
                <el-table-column prop="menuName" label="系统功能" width="120" show-overflow-tooltip header-align="center"
                    align="left">
                    <template slot-scope="scope">{{ scope.row.surveyTitle || scope.row.menuName || '-' }}</template>
                </el-table-column>
                <el-table-column label="业务员价格" width="100" show-overflow-tooltip header-align="center" align="left">
                    <template slot-scope="scope">{{ scope.row.taskPrice }} {{ scope.row.taskPriceUnit }}</template>
                </el-table-column>
                <el-table-column label="计算方式" width="100" show-overflow-tooltip header-align="center" align="left">
                    <template slot-scope="scope">{{ scope.row.taskTotalType }}</template>
                </el-table-column>

                <el-table-column prop="taskTotal" show-overflow-tooltip label="计划量" header-align="center" align="left"
                    width="100">
                    <template slot-scope="scope">
                       
                        <div v-if="scope.row.taskTotalType == '不限量'" style="display: flex; align-items: center;">
                            <div>
                                不限量
                                <span style="color:#FF991C;">({{ scope.row.countRule }})</span>
                            </div>
                        </div>
                        <div v-else
                            style="display: flex; align-items: center;">
                            <div>{{ scope.row.taskAvg }}</div>
                            <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                            <span style="color:#FF991C;">({{ scope.row.countRule }})</span>
                        </div>

                    </template>
                </el-table-column>

                <el-table-column prop="realCount" show-overflow-tooltip label="实际量" header-align="center" align="left" width="100">
                    <template slot-scope="scope">{{  scope.row.realCount!=null?scope.row.realCount:'-'  }}</template>
                </el-table-column>

                <el-table-column label="进度" width="100" show-overflow-tooltip header-align="center" align="left">
                    <template slot-scope="scope">{{ scope.row.finishRate!=null?scope.row.finishRate+'%':'-' }}</template>
                </el-table-column>

                <el-table-column prop="bank" min-width="120px" label="操作" header-align="center" align="center"
                    fixed="right">
                    <template slot-scope="scope">
                        <a class="txt-color" @click="rowDetail = scope.row; showRowDetail = true;">查看人员明细</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="btn-groups">
            <el-button class="btn-common btn-border-gray" size="mini" type="info" @click="$router.go(-1)">取消</el-button>
        </div>

        <PersonTaskSum :projectManagerStaffList="detail.projectManagerStaffList" :detail="rowDetail" v-if="showRowDetail" @close="showRowDetail = false;"></PersonTaskSum>


    </div>
</template>
  
<script>
import moment from 'moment';
import PersonTaskSum from './components/PersonTaskSum.vue';
export default {
    components: {
        PersonTaskSum,
    },
    data() {
        return {
            taskTitle:null,
            newTaskTitleTxt:null,
            detail:{},
            startTime:null,
            endTime:null,
            rowDetail: {},
            showRowDetail: false,
            tableDataII:[],
        };
    },
    created() {
        this.getDetail();
    },
    methods: {
        getMangeName(list) {
            if(!list||!list.length) return;
            let newArr = [];
            list.forEach(el => {
                newArr.push(el.name);

            })
            return newArr.join('、') || '-';
        },
        getName(name, key) {
            if (!name) return '-';
            let list = this.getCodeListByKey(key);
            if (typeof name == 'object') {
                let newArr = [];
                name.forEach(item => {
                    list.forEach(el => {
                        if (el.value == item) {
                            newArr.push(el.text);
                        }
                    })
                })
                return newArr.length ? newArr.join('、') : '-';

            } else {
                let lisArr = list.filter(item => item.value == name);
                return lisArr.length ? lisArr[0].text : '-';
            }

        },
        getDetail() {
            var self = this;
            if (!this.$route.query.guid) return;
            if (this.$route.query.is_edit) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }

            var req = {
                guid: this.$route.query.guid,
            };
            this.fullscreenLoading = true;
            self.api.get(`/${serverConfig.msSalesPerformService}/platform-task/detail`, req).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    let detail = res.data.data;
                    let regex = /\((.+?)\)/g;
                    let taskTitle = detail.taskTitle;
                    this.taskTitle = detail.taskTitle;
                    this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
                    this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
                    if (taskTitle.indexOf('(') > -1) {
                        this.newTaskTitleTxt = taskTitle.match(regex)[0].replace("(", "").replace(")", "");
                        this.taskTitle = taskTitle.split('(')[0];
                    } else {
                        this.taskTitle = taskTitle;
                    }


                    this.tableDataII = detail.taskDetailList;
                    var tableDataII = this.tableDataII;
                    tableDataII.forEach((item) => {
                        if (item.goodsInfo) {
                            item.goodsInfo = JSON.parse(item.goodsInfo);
                        }
                        if (item.taskPrice && item.taskTotal) {
                            item.taskTarget = item.taskPrice * item.taskTotal;
                            item.taskTarget = item.taskTarget.toFixed(2);
                        } else {
                            item.taskTarget = 0;
                        }
                    });
                    this.tableDataII = tableDataII;
                    this.detail = detail;
                    this.$forceUpdate();
                } else {
                    self.$message.error(res.data.msg);
                }
            });

        },
    },
};
</script> 
  
<style scoped>
/deep/ .table_header {
    background-color: #F0F0F0 !important;
    padding: 10px 0;
    color: #323233;
}

/deep/ .el-table td {
    padding: 10px 0px;
}

.p20 {
    padding: 0 20px;
}

.new-content {
    padding-top: 20px;
    padding-left: 20px;
    background: #fff;
    margin-bottom: 4px;
    padding-bottom: 10px;
}

.task-header {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding-bottom: 10px;
}

.lock-state {
    display: inline-block;
    margin-left: 10px;
    border-radius: 10px;
    font-weight: 400;
    background-color: #999;
    width: 50px;
    padding: 0 5px;
    font-size: 14px;
    text-align: center;
    color: #fff;
}

.task-content .item {
    display: flex;
    color: #666666;
    font-size: 14px;
}

.task-content .item div {

    padding-right: 20px;
    margin-right: 20px;
    border-right: 1px solid #E5E5E5;
    margin-top: 10px;
}

.task-content .item .last {
    border-right: 1px solid transparent;
}
</style>
  
<style scoped>
.title-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;

}

.search-box {
    width: 260px
}

.content {
    background: #fff;
    font-size: 18px;
}

/deep/.el-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

/deep/.el-form-item__content {
    margin-left: 0px !important;
}

.base-info {
    display: flex;
    align-items: center;
    margin-left: 23px;
    margin-bottom: 10px;
}

.base-info .base-title {
    word-break: keep-all;
    font-size: 14px;
    display: flex;
}

.depart-choose {
    width: 300px;
    height: 34px;
    border: 1px solid #dcdfe6;
    box-sizing: content-box;
    border-radius: 4px;
    cursor: pointer;
    text-align: left;
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-left: 6px;
}

.depart-choose span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
}

.place-choose {
    padding-left: 10px;
    color: rgb(185, 185, 185);
}

.place-show {
    padding-left: 20px;
}

.p16 {
    padding-top: 0;
    padding-left: 30px;
    padding-right: 30px;
}

.select-box {
    overflow: hidden;
    margin: 0 0px 10px 30px;
}

.box-left {
    width: 40%;
    height: 350px;
    padding: 0 20px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
    overflow-y: auto;
}

.box-right {
    width: 57%;
    height: 350px;
    padding: 0 10px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
}

.management-list {
    display: flex;
    align-items: center;
    margin-left: 64px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #606266;
}

.select-department {
    color: green;
    text-decoration: underline;
    cursor: pointer;
}

.management-name {
    flex-shrink: 0;
}

.designee {
    padding: 3px 10px 6px 10px;
    display: inline-block;
    /* border: 1px solid grey; */
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 20px;
    margin-right: 10px;
    border-radius: 20px;
    background: #DEEFEF;
    border: 0 none;
}

.input-item {
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-bottom: 25px;
}

.input-item .input-title {
    margin-right: 14px;
}

input:disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
}

.date {
    font-size: 14px;
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    padding-left: 30px;
    background: #fff;
}

.date.first {
    padding-top: 10px;
}

.title {
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    background: #fff;
    color: #323233;
    padding: 16px 0 10px 20px;
}

.title span {
    width: 6px;
    height: 14px;
    background: #4fa1a4;
    display: inline-block;
    margin-right: 10px;
}

.row-import {
    display: flex;
}

.row-import .left {
    font-size: 14px;
    font-weight: bold;
    margin-right: 20px;
    padding-top: 4px;
}

.row-import .right {
    font-size: 14px;
}

.tipInfo {
    margin-top: 10px;
    color: #646464;
    line-height: 30px;
}

.task-tips {
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    color: red;
}

.ai-tips {
    height: 26px;
    background: #FFEEE3;
    color: #FF741E;
    line-height: 26px;
    font-size: 13px;
    padding-left: 10px;
}

.download-btns {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    align-items: center;
}

.ai-item .lable {
    font-size: 14px;
    color: #232323;
}

.ai-item {
    margin-top: 20px;
}

.ai-item .value {
    color: #333;
    font-weight: 600;
    margin-left: 5px;
}

.ai-item .other1 {
    color: #333;
    font-weight: 600;
    margin-left: 5px;
}

.ai-item .other2 {
    color: #4fa1a4;
    text-decoration: underline;
    cursor: pointer;
}

.ai-item .ai-color {
    color: #4fa1a4;
    margin-left: 8px;
}

.download-btns .lable {
    font-size: 14px;
    color: #232323;
    flex: 1;
}

.download-btns .btns {
    flex: 1;
    display: flex;
    color: #323233;
    justify-content: flex-end;

}

.download-btns .btn1 {
    margin-right: 20px;
}

.download-btns .btn1,
.download-btns .btn2 {
    border: 1px solid #D9D9D9;
    padding: 6px;
    border-radius: 4px;
}

/deep/.ai-class .el-dialog--center .el-dialog__body {
    padding: 0 25px;
}

.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.header {
    background: #fff;
    margin: 1px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.header .task-title {
    flex: 1;
    font-weight: 500px;
}

.basic-conetent {
    background: #fff;
    margin-bottom: 4px;
}

.btn-groups {
    background: #fff;
    padding-top: 4px;
}

.btn-groups .btn-common {
    width: 120px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.btn-border-green {
    background: #fff;
    color: #4fa1a4;
    border: 1px solid #4fa1a4;
}

.btn-border-gray {
    background: #f0f0f0;
    color: #323233;
    border: 1px solid #dcdee0;
}

.btn-operate {
    text-align: left;
}

.btn-operate .btn-common {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.sum-txt {
    background: #fff;
    text-align: left;
    padding-left: 30px;
}

.btn-operate .btn-common:last-child {
    margin-right: 30px;
}

.approve-item-list {
    display: flex;
    background: #fff;
    margin-bottom: 4px;
    align-items: center;
    padding-bottom: 16px;
    position: relative;
}

.approve-item-list .item {
    margin-left: 40px;
    display: flex;
}

.approve-item-list .label {
    color: #606266;
    margin-right: 15px;
}

.approve-item-list .item.first {
    margin-left: 50px;
}

.approve-item-list img {
    position: absolute;
    right: 40px;
    width: 70px;
    bottom: 8px;
}
</style>
  